import React, { useEffect } from "react";

const Pagination = ({ items, children }) => {
  const itemsPerPage = 9;
  const [currentItems, setCurrentItems] = React.useState([]);
  const [itemOffset, setItemOffset] = React.useState(0);
  const [pageCount, setPageCount] = React.useState(0);

  useEffect(() => {
    const filteredItems = items.filter((item) => !item.acf?.make_private);
    setCurrentItems(filteredItems.slice(0, itemsPerPage));
    setItemOffset(0);
    setPageCount(Math.ceil(filteredItems.length / itemsPerPage));
  }, [items]);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    const filteredItems = items.filter((item) => !item.acf?.make_private);
    setCurrentItems(filteredItems.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(filteredItems.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage;
    setItemOffset(newOffset);
  };

  return children(currentItems, handlePageClick, pageCount);
};

export default Pagination;

/**
 * 
 * Old code before adding capability if ACF field make_private is true exclude item from the results
 * - JH 04/24/2023
 * 
import React, { useEffect } from "react";
import { useLocation, navigate } from "@reach/router";
const Pagination = ({ items, children }) => {
  const itemsPerPage = 9;
  const [currentItems, setCurrentItems] = React.useState(
    items.slice(0, itemsPerPage)
  );
  React.useLayoutEffect(() => {
    window.moduleRegistry.init();
  });
  const [itemOffset, setItemOffset] = React.useState(0);
  useEffect(() => {
    setCurrentItems(items.slice(0, itemsPerPage));
    setItemOffset(0);
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [items]);
  const [pageCount, setPageCount] = React.useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.

  React.useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  return children(currentItems, handlePageClick, pageCount);
};

export default Pagination;
*/
